// import { createContext } from "react";

import { createContext } from "react";

const OrderContext = createContext();

export default OrderContext;